import {
  Card, CardContent, CardHeader,
  CircularProgress, Paper, Container, colors, Input,
  DialogActions, DialogTitle, DialogContent, Dialog, Slide, LinearProgress, Button,
  Divider, Grid, CardActions, FormControl, InputAdornment, TextField, TableSortLabel, TablePagination,
  TableContainer, Table, TableHead, TableCell, TableRow, TableBody, CardMedia, Tabs, Tab, Backdrop, Typography, Snackbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from "src/utils/axios";
import React, { useEffect, UseState } from 'react';
import Page from 'src/components/Page';
import ImageCencelIcon from '@material-ui/icons/Cancel';
import { getUser, CreateWareHouseAddress } from 'src/utils/Common';
import MuiAlert from '@material-ui/lab/Alert';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import SendIcon from '@material-ui/icons/Send';
import AddressSearch from 'src/components/Selects/AddressSearch';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  tableContainer: {
    maxHeight: '100%',
    overflow: 'auto',
  },
}));
const defaultUyari = { open: false, aciklama: '', tip: 'success' };

function Pass() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [dataPaslasma, setPaslasmaData] = React.useState([]);
  const [uyari, setUyari] = React.useState(defaultUyari);
  const [pagination, setPagination] = React.useState({ page: 0, rowsPerPage: 10 });
  const user = getUser();
  const [containerHeight, setContainerHeight] = React.useState('auto');
  const [passEditParam, setPassEditParam] = React.useState('');

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      const headerHeight = document.querySelector('header').offsetHeight;
      const newHeight = windowHeight - headerHeight - 200; // 50 is a buffer for padding/margin
      setContainerHeight(newHeight);
    };

    handleResize(); // Initial call to set height

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };



  const GetOpenPassByService = () => {
    setLoading(true);
    axios.get("GetOpenPassByService/1/" + user.ServiceShopId)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
    GetOpenPassByService();
  }, []);

  function PassProcess(ISLEM_TIPI, ID) {
    confirmAlert({
      message: 'Paslaşma talebi iptal edilecektir. Devam etmek istediğinzden eminmisiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => PassProcessKabul(ISLEM_TIPI, ID)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }
  function PassProcessKabul(ISLEM_TIPI, ID) {
    setLoading(true);
    const data = {
      ISLEM_TIPI: ISLEM_TIPI,
      ID: ID,
      USERID: user.UserId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassProcess', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }




  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [passEdit, setPassEdit] = React.useState(false);

  const GetPassEditPopUp = (event, ID) => {
    setPassEditParam(ID);
    setPassEdit(true);
  }


  const [Envalue, setEnvalue] = React.useState();

  const handleEnInputChange = (event) => {
    setEnvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Boyvalue, setBoyvalue] = React.useState();

  const handleBoyInputChange = (event) => {
    setBoyvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Yukseklikvalue, setYukseklikvalue] = React.useState();

  const handleYukseklikInputChange = (event) => {
    setYukseklikvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Desivalue, setDesivalue] = React.useState();

  const handleDesiInputChange = (event) => {
    setDesivalue(event.target.value === '' ? '' : event.target.value);
  };

  const [KargoTutarvalue, setKargoTutarvalue] = React.useState();

  const handleKargoTutarInputChange = (event) => {
    setKargoTutarvalue(event.target.value === '' ? '' : event.target.value);
  };

  function SetKargoBilgisi() {

    var DepoAdres = dataPaslasma.filter(d => d.ID === passEditParam);

    var DepoAdresId = DepoAdres[0].WarehouseAddress;




    const data = {
      EN: Envalue,
      BOY: Boyvalue,
      YUKSEKLIK: Yukseklikvalue,
      DESI: Desivalue,
      KARGO_TUTAR: KargoTutarvalue,
      ID: passEditParam,
      USERID: user.UserId,
      DepoAdresId: DepoAdresId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };




    axios.post('/SetPassKargoBilgisi', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
        setPassEdit(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });
  }

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${user.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...dataPaslasma];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setPaslasmaData(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title={'Paslaşmadan Gelen Malzeme Girişi'}></CardHeader>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <TableContainer  className={classes.tableContainer} style={{ height: containerHeight }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">GirişYap</TableCell>
                    <TableCell align="left">İptal</TableCell>
                    <TableCell align="left">PaslaşmaNo</TableCell>
                    <TableCell align="left">GönderenServis</TableCell>
                    <TableCell align="left">Adı</TableCell>
                    <TableCell align="left">Telefon</TableCell>
                    <TableCell align="left">Tarih</TableCell>
                    <TableCell align="left">Durum</TableCell>
                    <TableCell align="left">MalzemeKodu</TableCell>
                    <TableCell align="left">Malzeme</TableCell>
                    <TableCell align="left">Adet</TableCell>
                    <TableCell align="left">GönderiTip</TableCell>
                    <TableCell align="left">GönderiKodu</TableCell>
                    <TableCell align="left">KargoÖdeme</TableCell>
                    {/* <TableCell align="left">En</TableCell>
                    <TableCell align="left">Boy</TableCell>
                    <TableCell align="left">Yükseklik</TableCell>
                    <TableCell align="left">Desi</TableCell>
                    <TableCell align="left">KargoTutar</TableCell> */}
                    <TableCell align="left">Adres</TableCell>
                    <TableCell align="left">AdresAdet</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataPaslasma.slice(pagination.page * pagination.rowsPerPage, (pagination.page + 1) * pagination.rowsPerPage).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left" className={classes.tableCell}>
                        {
                          row.EDITKARGO === 0 ? '' : <SendIcon
                            onClick={(event) => GetPassEditPopUp(event, row.ID)}
                            //onClick={() => PassEdit(row.ID)}
                            color="primary" />
                        }
                      </TableCell>
                      <TableCell align="left">
                        {
                          row.IPTAL === 0 ? '' : <DeleteForeverIcon
                            onClick={() => PassProcess(3, row.ID)}
                            color="error" />
                        }
                      </TableCell>
                      <TableCell align="left" >
                        {row.PASLASMA_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.SERVIS}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TALEP_EDEN}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TELEFON}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TARIH}
                      </TableCell>
                      <TableCell align="left" >
                        {row.DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_STOK_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_ACIKLAMA}
                      </TableCell>
                      <TableCell align="left">
                        {row.ADET}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_TIP}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_KODU}
                      </TableCell>
                      <TableCell align="left">
                        {row.KARGO_ODEME_DURUM}
                      </TableCell>
                      {/* <TableCell align="left">
                        {row.EN}
                      </TableCell>
                      <TableCell align="left">
                        {row.BOY}
                      </TableCell>
                      <TableCell align="left">
                        {row.YUKSEKLIK}
                      </TableCell>
                      <TableCell align="left">
                        {row.DESI}
                      </TableCell>
                      <TableCell align="left">
                        {row.KARGO_TOPLAM_TUTAR}
                      </TableCell> */}
                      <TableCell align="left">
                        <AddressSearch
                          setAdres={setAdres}
                          value={{
                            Id: row.WarehouseAddress || '0',
                            Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                            Materials: row.Malzemeleri | ''
                          } || ''}
                          searchParam={search}
                          MaterialCode={row.MALZEME_STOK_NO}
                          ServicePaperNr={row.FIS_NO}
                          index={index}
                          Adres={row.WarehouseAddress || 0}
                          RowSelected={1}
                          Tip={"Cikis1"}
                        />
                      </TableCell>
                      <TableCell align="left">
                        {row.ADRES_ADET}
                      </TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={dataPaslasma.length}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page}
              onChangePage={(e, v) => setPagination({ ...pagination, page: v })}
              onChangeRowsPerPage={e => setPagination({ page: 0, rowsPerPage: e.target.value })}
            />
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={passEdit}
        onClose={() => setPassEdit(false)}
        keepMounted
        maxWidth={'sm'}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Kargo Bilgileri
        </DialogTitle>
        <Divider />
        <DialogContent>
          {/* <div className={classes.root}>          
          <Typography id="input-slider" gutterBottom>
            En
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Input
                className={classes.input}
                value={Envalue}
                margin="dense"
                onChange={handleEnInputChange}
              />
            </Grid>
          </Grid>

          <Typography id="input-slider" gutterBottom>
            BOY
          </Typography>
          <Grid container spacing={2} alignItems="center">
          <Grid item>
              <Input
                className={classes.input}
                value={Boyvalue}
                margin="dense"
                onChange={handleBoyInputChange}
              />
            </Grid>
          </Grid>

          <Typography id="input-slider" gutterBottom>
            YÜKSEKLİK
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Input
                className={classes.input}
                value={Yukseklikvalue}
                margin="dense"
                onChange={handleYukseklikInputChange}
              />
            </Grid>
          </Grid>


          <Typography id="input-slider" gutterBottom>
            DESİ
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Input
                className={classes.input}
                value={Desivalue}
                margin="dense"
                onChange={handleDesiInputChange}
              />
            </Grid>
          </Grid>


          <Typography id="input-slider" gutterBottom>
            KARGO TUTAR
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Input
                className={classes.input}
                value={KargoTutarvalue}
                margin="dense"
                onChange={handleKargoTutarInputChange}
              />
            </Grid>
          </Grid>

           
          </div> */}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => SetKargoBilgisi()}
            className={classes.button}
            endIcon={<SendIcon>Close</SendIcon>}
          >
            Gİrİş Yap
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Pass;
